import { reducer, initialState } from '#base/Canvas/Reducer.js';
import { configureStore } from '@reduxjs/toolkit';

export default configureStore({
  reducer,
  preloadedState: initialState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
});
